import { FC, HTMLProps } from 'react'
import Link, { LinkProps } from 'next/link'

import { SessionStorageKeys } from 'constants/storage'

interface IOriginLink extends LinkProps, Pick<HTMLProps<HTMLAnchorElement>, 'target' | 'style'> {
  origin?: string
  className?: string
}

const OriginLink: FC<IOriginLink> = (props) => {
  const setOrigin = () => {
    sessionStorage.setItem(SessionStorageKeys.ANALYTIC_ORIGIN, props.origin || '')
  }
  return (
    <Link {...props} onClick={props.origin ? setOrigin : undefined}>
      {props.children}
    </Link>
  )
}

export default OriginLink
